import React, { useEffect, useState } from "react";
import "./CartDetailsComponent.css";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Apiurl, Encryption } from "../../Pages/utils/page";
import ProductCountdown from "../Countdown/Countdown";
import CartDetailModal from "./CartDetailModal";
import CartDetailPayModal from "./CartDetailPayModal";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CartDetailsComponent = ({
  cartOrder,
  cartItems,
  handleRemoveCartOrder,
  handleRemoveCartItem,
  setUpdatedBidValue,
  handleUpdateBid,
  updatedBidValue,
  handleChangeSelectedQuantity,
  handleIncreaseSelectedQuantity,
  handleDecreaseSelectedQuantity,
  handlePayment,
  selectedAddress,
  setSelectedAddress,
  totalValue,
  setTotalValue,
  loading,
  combinePromoData,
  deliveryCharge,
  handleApplyPromo,
  applyButton,
  setApplyButton,
  handleRemovePromo,
  finalValue,
  promoClickData,
  setFinalValue,
}) => {
  const router = useNavigate();

  const [show, setShow] = useState();
  const [paymentShow, setPaymentShow] = useState(false);

  useEffect(() => {
    if (cartOrder?.length) {
      const totalAmount = cartOrder?.reduce((total, item) => {
        return total + item.selectedQuantity * item.DealPrice;
      }, 0);
      setTotalValue(totalAmount);

    }
  }, [cartOrder]);

  return (
    <>
      <div className="banner_section" style={{ flex: "1" }}>
        <div>
          <div className="cart_main_section_01">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="cart-warrper">
                    <h4 className="common_heading">Order Items</h4>
                    <div className="row">
                      {cartOrder?.length ? (
                        <>
                          <div className="col-lg-9 col-sm-8 col-12">
                            <div className="row">
                              {cartOrder?.map((item) => {
                                const imagesArray = JSON.parse(item.Images);

                                const defaultImage = imagesArray.find(
                                  (img) => img.Default
                                );

                                const imageUrl = defaultImage
                                  ? `${Apiurl()}/${defaultImage.Images}`
                                  : "";

                                return (
                                  <div className="col-lg-12">
                                    <div className="cart_order_section">
                                      <div className="cart_order_wraper">
                                        <div className="row">
                                          <div className="col-lg-3 col-sm-3 col-4">
                                            <a>
                                              <img
                                                src={imageUrl}
                                                className="cart_order_image"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src =
                                                    "/Images/no-product-img-700.jpg";
                                                }}
                                                onClick={() => {
                                                  router(
                                                    `/productdetail/${Encryption(
                                                      item?.ProductId
                                                    )}`
                                                  );
                                                }}
                                              />
                                            </a>
                                          </div>
                                          <div className="col-lg-8 col-sm-8 col-7 cart_order_content">
                                            <div>
                                              <h3>{item?.ProductName}</h3>
                                              <p>{item?.ProductDescription} </p>

                                              <div className="quantity">
                                                <button
                                                  className="minus"
                                                  onClick={() =>
                                                    handleDecreaseSelectedQuantity(
                                                      item
                                                    )
                                                  }
                                                >
                                                  −
                                                </button>
                                                <input
                                                  className="input-box"
                                                  value={item?.selectedQuantity}
                                                  onChange={(e) =>
                                                    handleChangeSelectedQuantity(
                                                      e,
                                                      item
                                                    )
                                                  }
                                                />
                                                <button
                                                  className="plus"
                                                  onClick={() =>
                                                    handleIncreaseSelectedQuantity(
                                                      item
                                                    )
                                                  }
                                                >
                                                  +
                                                </button>
                                              </div>
                                              <h5>
                                                Available Quantity:{" "}
                                                <span>
                                                  {" "}
                                                  {item?.AvailableQTY}
                                                </span>
                                              </h5>
                                              <h5>
                                                Deal Price:{" "}
                                                <span>₹ {item?.DealPrice}</span>
                                              </h5>
                                            </div>
                                          </div>
                                          <div className="col-lg-1 col-sm-1 col-1">
                                            <div className="cart_remove_order">
                                              <IoIosCloseCircleOutline
                                                className="cross_icon_cart"
                                                onClick={() =>
                                                  handleRemoveCartOrder(item)
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-4 col-12">
                            <div className="cart-checkout-wrapper">
                              <h3> CART TOTALS</h3>
                              <p>
                                {" "}
                                Total Amount:<span> ₹ {totalValue}</span>
                              </p>
                              <input
                                type="button"
                                value="Proceed"
                                className="payment_btn common_btn w-100"
                                onClick={() => setPaymentShow(true)}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="col-lg-12 col-sm-12">
                          <div className="cart_notdata-box">
                            <p className="mb-1">No items in Order</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="cart-bid-warrper">
                    <div className="update_bid_secton">
                      <h4 className="common_heading">Bid Items</h4>
                      <span className="update_bid_pt-txt">
                        {" "}
                        (Update bid points by input)
                      </span>
                    </div>
                    <div>
                      <div className="row">
                        {cartItems?.length > 0 ? (
                          <>
                            <div className="col-lg-12">
                              <div className="table-responsive custom-table">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="product-thumbnail">
                                        Image
                                      </th>
                                      <th className="product-name">
                                        Product Name
                                      </th>
                                      <th className="product-price">
                                        Recommended Bid Points
                                      </th>
                                      <th className="product-quantity">
                                        Points
                                      </th>
                                      <th className="product-quantity bid_timelf_wdth">
                                        Time Left
                                      </th>
                                      <th className="product-remove bid_remove_icon_wdth">
                                        Remove
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cartItems?.map((item) => {
                                      const image = item?.Image?.split('"');
                                      const imageUrl = `${Apiurl()}/${
                                        image?.[3]
                                      }`;
                                      const now = moment(); // Current time
                                      const timeTo = moment(
                                        item?.ProductToPublishDate
                                      );
                                      const timeDifferenceInHours = timeTo.diff(
                                        now,
                                        "hours"
                                      );
                                      return (
                                        <tr key={item?.id}>
                                          <td className="bid_cart_img_wdth">
                                            <img
                                              src={imageUrl}
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "/Images/no-product-img-700.jpg";
                                              }}
                                              onClick={() => {
                                                router(
                                                  `/productdetail/${Encryption(
                                                    item?.ProductId
                                                  )}`
                                                );
                                              }}
                                            />
                                          </td>
                                          <td className="bid_pro_des-wdth">
                                            {item?.ProductName}{" "}
                                          </td>
                                          <td className="bid_rec_pint_wdth">
                                            {item.RecommendedBid}
                                          </td>
                                          <td className="bid_cart_point_wdth">
                                            <div className="bid_cart-form gap-2">
                                              <div className="bid_amount">
                                                <span>{item?.BidAmount}</span>
                                              </div>
                                              <div className="bid_amount">
                                                <span></span>
                                              </div>
                                              <input
                                                type="number"
                                                placeholder=" Enter Bid Point"
                                                onChange={(e) =>
                                                  setUpdatedBidValue(
                                                    (prev) => ({
                                                      ...prev,
                                                      [item.ProductId]:
                                                        e.target.value,
                                                    })
                                                  )
                                                }
                                                value={
                                                  updatedBidValue[
                                                    item.ProductId
                                                  ] || ""
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="eg-btn view-data-btn"
                                                onClick={() =>
                                                  handleUpdateBid(item)
                                                }
                                              >
                                                Update
                                              </button>
                                            </div>
                                          </td>
                                          <td className="bid_timelf_wdth">
                                            {timeDifferenceInHours > 24 ? (
                                              
                                              <>
                                                  Till:{" "}
                                                  {moment(
                                                    item?.ProductToPublishDate
                                                  ).format("LL")}
                                                
                                                  </>
                                            ) : (
                                              <ProductCountdown
                                                item={item}
                                                val="checkTime"
                                              />
                                            )}
                                          </td>
                                          <td className="bid_remove_icon_wdth">
                                            <IoIosCloseCircleOutline
                                              className="cross_icon_cart"
                                              onClick={() =>
                                                handleRemoveCartItem(item)
                                              }
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-lg-12 col-sm-12">
                            <div className="cart_notdata-box">
                              <p className="mb-1">No items</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CartDetailModal
        show={show}
        setShow={setShow}
        handlePayment={handlePayment}
        setSelectedAddress={setSelectedAddress}
        selectedAddress={selectedAddress}
        loading={loading}
      />
      <CartDetailPayModal
        combinePromoData={combinePromoData}
        deliveryCharge={deliveryCharge}
        handleApplyPromo={handleApplyPromo}
        applyButton={applyButton}
        setApplyButton={setApplyButton}
        handleRemovePromo={handleRemovePromo}
        paymentShow={paymentShow}
        setPaymentShow={setPaymentShow}
        finalValue={finalValue}
        totalValue={totalValue}
        promoClickData={promoClickData}
        setShow={setShow}
        setFinalValue={setFinalValue}
      />
    </>
  );
};

export default CartDetailsComponent;
